import { Component, OnInit, Inject } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AdminService } from '../services/admin.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SubArea } from '../../shared/models/subarea.interface';
import { finalize } from 'rxjs/operators';
import { IncomeAccount } from '../../shared/models/income.account.interface';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericDialogData } from '../models/generic.dialog.interface';
import { Area } from '../../shared/models/area.interface';

@Component({
  selector: 'app-subarea',
  templateUrl: './subarea.component.html',
  styleUrls: ['./subarea.component.scss']
})
export class SubareaComponent implements OnInit {

  constructor(private adminService: AdminService, private route: ActivatedRoute, private router: Router, public dialogRef: MatDialogRef<SubareaComponent>, @Inject(MAT_DIALOG_DATA) public data: GenericDialogData) { }
  subArea: SubArea;
  areas: Area[];
  accounts: IncomeAccount[];
  laborRate: number = null;
  pieceRate: number = null;
  errors: string;
  isRequesting: boolean;

  ngOnInit() {
    let subAreaId: string = this.data.id;
    let dealerId = this.adminService.getDealerId();

    if (subAreaId == null) {
      this.subArea = {} as SubArea;
      this.subArea.subArea_IsActive = true;
    }
    else {
      this.adminService.getSubArea(subAreaId)
        .subscribe({
          next: (data) => {
            this.subArea = data;
          }
})
    }

    this.adminService.getAreaList(dealerId)
      .subscribe({
        next: (data) => {
          this.areas = data.sort((a, b) => a.area_Name < b.area_Name ? -1 : 1);
        }
      });

    this.adminService.getAccounts(dealerId)
      .subscribe({
        next: (data) => {
          this.accounts = data;
        }
      });

  }

  calcLaborCost() {
    if (this.laborRate != null && this.pieceRate != null) {
      this.subArea.subArea_LaborCost = this.laborRate / this.pieceRate;
      this.laborRate = null;
      this.pieceRate = null;
    }
  }

  saveSubArea(form: NgForm) {
    this.route.paramMap.subscribe(params => {
      console.log('in subarea onSubmit: ', this.subArea);
      this.errors = '';
      if (form.valid) {
        this.isRequesting = true;

        let dealerId = this.adminService.getDealerId();
        this.subArea.dealer_ID = dealerId;

        this.adminService.saveSubArea(this.subArea)
          .pipe(finalize(() => this.isRequesting = false))
          .subscribe({
            next: (result) => {
              if (result) {
                this.dialogRef.close();
              }
            },
            error: (error: string) => this.errors = error
          });
      }
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
